import React from "react";
import {Button, DropdownMenuItem} from "@reside/ui";

import {getResidentTestId} from "../../../helper";
import {
  ModalName,
  useDashboardModalContext,
} from "../../../DashboardModalContext";
import {AdmissionFromSearch} from "../../../../../services/AdmissionsService";

const useArchiveAdmissionAction = (admission: AdmissionFromSearch) => {
  const {toggleModal: toggleArchiveModal} = useDashboardModalContext(
    ModalName.ARCHIVE,
  );
  const onArchive = () => {
    toggleArchiveModal(admission);
  };
  const testId = getResidentTestId(admission, "ARCHIVED");
  return {onArchive, testId};
};

export const ArchiveAdmissionDropdownItem = ({
  admission,
}: {
  admission: AdmissionFromSearch;
}) => {
  const {onArchive, testId} = useArchiveAdmissionAction(admission);

  return (
    <DropdownMenuItem onClick={onArchive} testId={testId}>
      Archive
    </DropdownMenuItem>
  );
};

export const ArchiveAdmissionFooterButton = ({
  admission,
}: {
  admission: AdmissionFromSearch;
}) => {
  const {onArchive, testId} = useArchiveAdmissionAction(admission);

  return (
    <Button
      size="small"
      color="primary"
      outline
      flat
      onClick={onArchive}
      testId={testId}
    >
      Archive
    </Button>
  );
};
